import { Component, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { UpdateFleetUserDialogData, UpdateFleetUserRequest, UpdateFleetUserResponse, ErmDevOpsApiClientService } from 'erm-sdk';

@Component({
  standalone: false,
  selector: 'app-update-fleet-user',
  templateUrl: './update-fleet-user.component.html',
  styleUrls: ['./update-fleet-user.component.scss']
})
export class UpdateFleetUserComponent {

  isSaving: boolean = false;
  updateFleetUserRequest: UpdateFleetUserRequest;
  updateFleetUserResponse?: UpdateFleetUserResponse;

  constructor(private ermDevOpsApiClient: ErmDevOpsApiClientService,
    @Inject(MAT_DIALOG_DATA) public updateFleetUserDialogData: UpdateFleetUserDialogData,
    public dialogRef: MatDialogRef<UpdateFleetUserComponent>) {
    let customerIdAndUserEmail = updateFleetUserDialogData.fleetUser?.userId?.split(':') as string[];
    this.updateFleetUserRequest = {
      customerId: customerIdAndUserEmail[0],
      userEmail: customerIdAndUserEmail[1],
      isEnabled: updateFleetUserDialogData.fleetUser?.isEnabled,
      fleetKind: updateFleetUserDialogData.fleetUser?.fleetKind,
      allowList: ["*"]
    };
  }

  async save(): Promise<void> {
    try {
      this.isSaving = true;
      const updateFleetUserResponse = await this.ermDevOpsApiClient.updateFleetUser(this.updateFleetUserRequest);
      this.updateFleetUserResponse = updateFleetUserResponse.body as UpdateFleetUserResponse;
    } finally {
      this.isSaving = false;
    }
  }

  close(): void {
    this.dialogRef.close({ data: this.updateFleetUserResponse?.fleetUser });
  }
}
